<template>
  <SecondaryModal
    name="delete-blog"
    :title="$t('blog.delete')"
    @before-open="reset"
  >
    <div v-if="blog">{{ $t('deleteConfirmation') }} <b>{{ blog.blogInfoDisplay.name }}</b>?</div>

    <template v-slot:footer>
      <BaseButton oval secondary @click="$modal.hide('delete-blog')">{{ $t('buttonCancel') }}</BaseButton>
      <BaseButton oval :loading="loading" @click="deleteRequest">{{ $t('buttonDelete') }}</BaseButton>
    </template>
  </SecondaryModal>
</template>

<script>
import SecondaryModal from './SecondaryModal'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'delete-blog-popup',
  components: {
    SecondaryModal
  },
  data () {
    return {
      loading: false,
      blogId: null
    }
  },
  computed: {
    ...mapGetters({
      blogById: 'entities/blogs/getBlog' // 'entities/blogs/find'
    }),
    blog () {
      return this.blogById(this.blogId)
    }
  },
  methods: {
    reset ({ params: { blogId } }) {
      this.loading = false
      this.blogId = blogId
    },
    ...mapActions({
      deleteBlog: 'entities/blogs/deleteBlog'
    }),
    async deleteRequest () {
      this.loading = true
      await this.deleteBlog(this.blog)
      this.loading = false
      this.$modal.hide('delete-blog')
      this.$modal.hide('edit-blog')
    }
  }
}
</script>

<style module lang="scss">

</style>
